var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Overrides styles of component with parameter style
 * @param localStyles - Internal component styles
 * @param externalStyles - External/Override component style
 */
export var overrideStyles = function (localStyles, externalStyles) {
    var classNameList = Object.keys(localStyles);
    return classNameList.reduce(function (previousValue, currentValue) {
        var _a, _b;
        if (externalStyles && externalStyles[currentValue]) {
            return __assign({}, previousValue, (_a = {}, _a[currentValue] = concatClass(localStyles[currentValue], externalStyles[currentValue]), _a));
        }
        return __assign({}, previousValue, (_b = {}, _b[currentValue] = localStyles[currentValue], _b));
    }, {});
};
/**
 * Concat class name
 * @param classes - Classes name
 */
export var concatClass = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.join(' ');
};
//# sourceMappingURL=styles.js.map